// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"bff198a9","297":"aee57e23","643":"b0eb3173","787":"d1c23f26"}[chunkId] + ".chunk.js";
};